module.exports = __webpack_public_path__ + "media/images/cplook/mstile-310x310-a10ecfff1c5dce03deb984c3d2d5c822.png";